import React from 'react';
import { classes } from '@bloomberg/media-ui-core';

import { BaseAd } from '../BaseAd/index';
import { AdType, GlobalAdProps } from '../types';

import styles from './styles.module.css';

export type FullWidthAdProps = GlobalAdProps & {
  adType: AdType;
  isDecoupled?: boolean;
};

export const FullWidthAd = React.forwardRef<HTMLDivElement, FullWidthAdProps>(
  function FullWidthAdComponent(
    { className = '', name = 'FullWidthAd', isDecoupled = false, ...props },
    ref
  ) {
    return (
      <BaseAd
        ref={ref}
        className={classes(styles.fullWidthAd, { className })}
        name={name}
        isDecoupled={isDecoupled}
        {...props}
      />
    );
  }
);
